module.exports = __webpack_public_path__ + "img/CJHY_ACT.90ae0202.png";